// src/redux/schedule/scheduleSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createSchedule, deleteSchedule, fetchSchedulesByConversationId } from './scheduleThunks';

const initialState = {
    loading: false,
    error: null,
    success: null,
    scheduledItems: [], // optional if you're listing messages too

    conByIdLoading: false,
    conByIdError: null,
    conByIdSuccess: null,

    conDeleteLoading:false,
    conDeleteError:null,
    conDeleteSuccess:null,


};

const scheduleSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        clearScheduleState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.success = 'Schedule created';
                state.scheduledItems.push(action.payload.data); // optional
            })
            .addCase(createSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(deleteSchedule.pending, (state) => {
                state.conDeleteLoading = true;
            })
            .addCase(deleteSchedule.fulfilled, (state, action) => {
                state.conDeleteLoading = false;
                state.conDeleteSuccess = 'Schedule deleted';
                state.scheduledItems = state.scheduledItems.filter(
                    (item) => item._id !== action.payload.id
                );
            })
            .addCase(deleteSchedule.rejected, (state, action) => {
                state.conDeleteLoading = false;
                state.conDeleteError = action.payload;
            })
            .addCase(fetchSchedulesByConversationId.pending, (state) => {
                state.conByIdLoading = true;
            })
            .addCase(fetchSchedulesByConversationId.fulfilled, (state, action) => {
                state.conByIdLoading = false;
                state.conByIdSuccess = action.payload;
            })
            .addCase(fetchSchedulesByConversationId.rejected, (state, action) => {
                state.conByIdLoading = false;
                state.conByIdError = action.payload;
            });
    },
});

export const { clearScheduleState } = scheduleSlice.actions;
export default scheduleSlice.reducer;
